import { render, staticRenderFns } from "./comp_Hook-ProductPage-DescInfoAndMedia.vue?vue&type=template&id=5de324fa&scoped=true&"
import script from "./comp_Hook-ProductPage-DescInfoAndMedia.vue?vue&type=script&lang=js&"
export * from "./comp_Hook-ProductPage-DescInfoAndMedia.vue?vue&type=script&lang=js&"
import style0 from "./comp_Hook-ProductPage-DescInfoAndMedia.vue?vue&type=style&index=0&id=5de324fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de324fa",
  null
  
)

export default component.exports